<template>
  <div style="margin-top: 7vh">
    <v-card class="rounded-xl pa-10" flat>
      <div class="center-logo">
        <app-logo :logo="logo"></app-logo>
      </div>
      <div class="d-flex justify-center">
        <strong>Thanks, Uploaded successfully!</strong>
      </div>
      <div class="d-flex justify-center mt-5">
        <v-icon color="success" x-large>mdi-check-circle</v-icon>
      </div>
      <div class="d-flex justify-center mt-8">
        <v-btn
          @click="copyLink"
          class="capitalize mr-7"
          rounded
          color="primary"
        >
          <v-icon>mdi-link-variant</v-icon>
          Copy Link
        </v-btn>
        <v-btn @click="backToDashbord" class="capitalize mr-7" rounded>
          <v-icon>mdi-arrow-left</v-icon>
          Dashboard
        </v-btn>
        <v-btn @click="backToHome" class="capitalize" rounded>
          <v-icon>mdi-restart</v-icon>
          {{ redirectBtn }}
        </v-btn>
      </div>
    </v-card>
    <v-snackbar
      :color="snackBarColor"
      :outlined="isOutlined"
      v-model="snackbar"
    >
      {{ snackBarText }}
    </v-snackbar>
  </div>
</template>

<script>
import AppLogo from "./Logo";
export default {
  components: {
    AppLogo,
  },
  name: "UploadCompleted",
  props: {
    settings: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      isOutlined: false,
    };
  },
  computed: {
    redirectBtn() {
      return this.settings?.redirect_link &&
        this.$route.path.indexOf("request") > -1
        ? `Kindly visit ${this.settings?.redirect_link}`
        : "Record again";
    },
    logo() {
      return this.settings?.logo_url || null;
    },
  },
  methods: {
    backToHome() {
      if (
        this.settings?.redirect_link &&
        this.$route.path.indexOf("request") > -1
      ) {
        window.location.href = this.settings?.redirect_link;
      } else {
        window.location.reload();
      }
    },
    async copyLink() {
      const response = await window.axios.get(
        "/recordings/copy-link-of-last-recording"
      );
      const link = this.optimizedRecordingLink(
        response.data.id,
        response.data.domain
      );
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.snackBarText = "Recording link copied";
          this.snackbar = !this.snackbar;
          this.snackBarColor = "primary";
          this.isOutlined = true;
          console.log("Link copied to clipboard!");
        })
        .catch((error) => {
          this.snackBarText = "Failed to copy link to clipboard, try again!";
          this.snackbar = !this.snackbar;
          this.snackBarColor = "error";
          console.error("Failed to copy link to clipboard", error);
        });
    },
    optimizedRecordingLink(Id, domain) {
      let link = "";
      let appStage = process.env.NODE_ENV;
      let protocol = appStage === "development" ? "http://" : "https://";
      link = protocol + domain + "/share/" + Id;
      return link;
    },
    backToDashbord() {
      window.location.href = "https://dashboard.konvey.app/dashboard";
    },
  },
};
</script>

<style scoped></style>
